import React,{ Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

import PaymentForm from '../../../shared/components/PaymentForm';

import {urlRoot} from '../../../shared/utils'

class AgencyCreatePaymentMethod extends Component {
  constructor(){
    super();

    this.state = {
      error:null
    };
  }

  handleSubmit(data){
    const {
      match,
      history,
      activeAgency,
      activePaymentMethods,
      createPaymentMethod,
      updateAgency
    } = this.props;

    createPaymentMethod({
      token:data.token,
      last4:data.last4,
      kind:data.kind,
      agencyId:activeAgency.id
    })
      .then((res) => {
        if(!activeAgency.defaultPaymentMethodId || !activeAgency.defaultPaymentMethodId.length > 0){
          return updateAgency(activeAgency.id,{ defaultPaymentMethodId:res.instance.id });
        } else {
          return Promise.resolve();
        }
      })
      .then(() => history.push(`${urlRoot(match.url)}/account`));    
  }

  render(){
    const { match, history } = this.props;

    return (
      <div className='AgencyCreatePaymentMethod'>
        <Container>
          <Row className='EntityList-title'>
            <Col xs='6'>
              <h1>New Payment Method</h1>
            </Col>
            <Col xs='6'></Col>
          </Row>
          <Row>
            <Col xs='8'>
              <PaymentForm 
                createFormOnly
                onSubmit={(data) => this.handleSubmit(data)}
                allowCreateNewMethod
                showCancelButton
                onCancel={() => history.push(`${urlRoot(match.url)}/account`)}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

AgencyCreatePaymentMethod.propTypes = {
  //TODO: Fill in prop types for AgencyCreatePaymentMethod
};

AgencyCreatePaymentMethod.defaultProps = {
  //TODO: Fill in defaultProps for AgencyCreatePaymentMethod
};

export default AgencyCreatePaymentMethod;



// WEBPACK FOOTER //
// ./src/routes/AgencyCreatePaymentMethod/components/AgencyCreatePaymentMethod.js